import { HorizontalProgressBar } from '@/components/shared/components/HorizontalProgressBar';

import { ScoreCardMetricKey } from '../../shared/types/ScoreCardMetricKey';
import { AgentScoreCardMetrics, ChannelScoreCardMetrics } from '../types/AgentScoreCardMetrics';

interface MetricsHorizontalProgressProps {
  metric: ChannelScoreCardMetrics | AgentScoreCardMetrics;
  maxMetricsValues: ChannelScoreCardMetrics | AgentScoreCardMetrics;
  selectedMetricsType: ScoreCardMetricKey;
}

export const MetricsHorizontalProgress = ({
  metric,
  maxMetricsValues,
  selectedMetricsType,
}: MetricsHorizontalProgressProps) => {
  const channelRelativeProgressTotalPrincipalAmount =
    metric.totalPrincipalAmount.current > 0 && maxMetricsValues.totalPrincipalAmount.current > 0
      ? (metric.totalPrincipalAmount.current / maxMetricsValues.totalPrincipalAmount.current) * 100
      : 0;

  const channelRelativeProgressTotalLoansNumber =
    metric.totalLoansNumber.current > 0 && maxMetricsValues.totalLoansNumber.current > 0
      ? (metric.totalLoansNumber.current / maxMetricsValues.totalLoansNumber.current) * 100
      : 0;

  return (
    <HorizontalProgressBar
      variant="small"
      progressValue={
        selectedMetricsType === ScoreCardMetricKey.totalPrincipalAmount
          ? channelRelativeProgressTotalPrincipalAmount
          : channelRelativeProgressTotalLoansNumber
      }
      style={{
        marginBlock: 0,
      }}
    />
  );
};
